import { Bar, CartesianGrid, Cell, Line, ComposedChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Panel, Spinner } from "./common";
import { useFetch } from "../lib/useFetch";
import { fmt } from "../lib/api";

export function PnlWeekly() {
  const { data, error } = useFetch("/live/pnl-weekly", 300000);
  if (!data) return <Panel title="Untung / rugi sebenar setiap minggu (RM)" testid="pnl-weekly" className="mb-3">{error ? <p className="text-xs text-red-600" data-testid="pnl-error">Tidak dapat memuat data Moomoo sekarang - cuba sebentar lagi.</p> : <Spinner />}</Panel>;
  const w = data.weeks || [];
  return (
    <Panel title="Untung / rugi sebenar setiap minggu (RM)" testid="pnl-weekly" className="mb-3"
      right={<span className={`mono text-sm font-semibold ${data.total_myr >= 0 ? "text-emerald-600" : "text-red-600"}`} data-testid="pnl-total">Jumlah RM{fmt(data.total_myr, 2)}</span>}>
      <p className="mb-2 text-[11px] text-slate-500">Dari harga sebenar Moomoo (100 order terakhir setiap pasaran, FIFO), bila saham dijual. Kadar tukaran hari ini. Saham yang masih dipegang tidak dikira.</p>
      {!w.length ? <p className="text-xs text-slate-500" data-testid="pnl-empty">Belum ada jualan selesai dalam 90 hari.</p> : (
        <div className="h-56" data-testid="pnl-chart">
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={w} margin={{ top: 5, right: 8, left: 0, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
              <XAxis dataKey="week" tick={{ fontSize: 10 }} />
              <YAxis tick={{ fontSize: 10 }} width={48} />
              <Tooltip formatter={(v, n) => [`RM${fmt(v, 2)}`, n === "pnl_myr" ? "Minggu" : "Kumulatif"]} labelFormatter={(l) => `Minggu ${l}`} />
              <Bar dataKey="pnl_myr">{w.map((x) => <Cell key={x.week} fill={x.pnl_myr >= 0 ? "#10B981" : "#EF4444"} />)}</Bar>
              <Line dataKey="cumulative_myr" stroke="#2563EB" dot={false} strokeWidth={2} />
            </ComposedChart>
          </ResponsiveContainer>
        </div>)}
      {!!data.note_unknown_cost?.length && <p className="mt-1 text-[10px] text-amber-700" data-testid="pnl-unknown">Kos belian tidak diketahui (dibeli sebelum 90 hari): {data.note_unknown_cost.join(", ")}</p>}
    </Panel>
  );
}
